
import actionType from "./actionTypes";
import axios from "axios";
import { toast } from "react-toastify";
import { hideIsLoading, showIsLoading, refreshApiService } from "../common/action";


import URL from "../../assets/config";
export const patientRegisterService = payload => dispatch => {
  toast.dismiss();

  dispatch(showIsLoading());

  const config = {
    method: 'post',
    url: URL.patient.PATIENT_REGISTER,
    data: payload
  };
  axios(config).then((res) => {
    dispatch(hideIsLoading());
    if (res.status === 200) {
      dispatch({
        type: actionType.PATIENT_REGISTER_SUCCESS,
        payload: payload,
        message: res.data.message
      });
      // toast.success(res.data.message,"You can login now");

    } else if (res.status === 206) {
      dispatch({
        type: actionType.PATIENT_REGISTER_FAILURE,
        error: res.data.message
      })
      toast.error(res.data.message);
    }
  }).catch(error => {
    dispatch(hideIsLoading());
    dispatch({
      type: actionType.PATIENT_REGISTER_FAILURE,
      error: error
    });
    toast.error(error.response.data.message)
  });
};



export const newFacilityRequest = (token, payload, ) => dispatch => {
  toast.dismiss();

  dispatch(showIsLoading());

  const config = {
    method: 'post',
    url: URL.patient.NEW_FACILITY_REQUEST,
    data: payload,
    headers: {
      'Content-Type': "application/json",
      "Authorization": 'bearer  ' + token,
    },
  };
  axios(config).then((res) => {
    dispatch(hideIsLoading());
    if (res.status === 200) {
      dispatch({
        type: actionType.NEW_FACILITY_REQUEST_SUCCESS,
        message: res.data.message
      });
    } else if (res.status === 206) {
      dispatch({
        type: actionType.NEW_FACILITY_REQUEST_FAILURE,
        error: res.data.message
      })
    }
  }).catch(error => {
    dispatch(hideIsLoading());
    if(error.response.data.error === "invalid_token"){
      dispatch(refreshApiService(newFacilityRequest, payload))
    }
    dispatch({
      type: actionType.NEW_FACILITY_REQUEST_FAILURE,
      error: error
    });
  });
};


export const getPatientRecordReqList = (token, patientId, ) => dispatch => {
  toast.dismiss();

  const config = {
    method: 'get',
    url: URL.patient.PATIENT_REQUEST_INFO + patientId,
    headers: {
      'Content-Type': "application/json",
      "Authorization": 'bearer  ' + token,
    },
  };
  axios(config).then((res) => {
    if (res.status === 200) {
      dispatch({
        type: actionType.PATIENT_REQUEST_INFO_SUCCESS,
        payload: res.data,
        message: res.data.message
      });
    } else if (res.status === 206) {
      dispatch({
        type: actionType.PATIENT_REQUEST_INFO_FAILURE,
        error: res.data.message
      })
    }

  }).catch(error => {
    dispatch(hideIsLoading());
    if(error.response.data.error === "invalid_token"){
       dispatch(refreshApiService(getPatientRecordReqList, patientId))
    }
    dispatch({
      type: actionType.PATIENT_REQUEST_INFO_FAILURE,
      error: error.message
    })
  });

};


export const facilityList = token => dispatch => {
  toast.dismiss();

  dispatch(showIsLoading());

  const config = {
    method: 'get',
    url: URL.employee.GET_FACILITY_LIST,
    headers: {
      'Content-Type': "application/json",
      "Authorization": 'bearer  ' + token,
    },
  };

  axios(config).then((res) => {
 

    dispatch(hideIsLoading());
    if (res.status === 200) {
      dispatch({
        type: actionType.FACILITY_LIST_SUCCESS,
        payload: res.data,
        message: res.data.message
      });
    } else if (res.status === 206) {
      dispatch({
        type: actionType.FACILITY_LIST_FAILURE,
        error: res.data.message
      })
    }
  }).catch(error => {
    dispatch(hideIsLoading());
    if(error.response.data.error == "invalid_token"){
      dispatch(refreshApiService(facilityList))
    }
    dispatch({
      type: actionType.FACILITY_LIST_FAILURE,
      error: error
    });
  });
};



export const getByPractice = (token) => dispatch => {
  toast.dismiss();

  dispatch({
    type: actionType.SEARCH_BY_ALL_FAILURE,
   })

  dispatch(showIsLoading());
  dispatch(getByDoctor(token));
  dispatch(getByLocation(token));
  // var formData = new FormData();
  // formData.append('searchFacility','');

  var formBody = [];
  formBody.push("searchFacility" + "=" + "");
  formBody = formBody.join("&");



  const config = {
    method: 'post',
    url: URL.patient.GET_BY_PRACTICE,
    data: formBody,
    headers: {
      'Content-Type': "application/x-www-form-urlencoded",
      "Authorization": 'bearer  ' + token,
    }
  };
  axios(config).then((res) => {

    dispatch(hideIsLoading());
    if (res.status === 200) {
      dispatch({
        type: actionType.GET_BY_PRACTICE_SUCCESS,
        payload: res.data,
        message: res.data.message
      });
    } else if (res.status === 206) {
      dispatch({
        type: actionType.GET_BY_PRACTICE_FAILURE,
        error: res.data.message
      })
    }
  }).catch(error => {
    dispatch(hideIsLoading());
    if(error.response.data.error == "invalid_token"){
      dispatch(refreshApiService(getByPractice))
    }
    dispatch({
      type: actionType.GET_BY_PRACTICE_FAILURE,
      error: error
    });
  });
};



export const getByDoctor = (token) => dispatch => {
  toast.dismiss();

  dispatch(showIsLoading());
  // var formData = new FormData();
  // formData.append('searchPractioner','');

  var formBody = [];
  formBody.push("searchPractioner" + "=" + "");
  formBody = formBody.join("&");


  const config = {
    method: 'post',
    url: URL.patient.GET_BY_DOCTOR,
    data: formBody,
    headers: {
      'Content-Type': "application/x-www-form-urlencoded",
      "Authorization": 'bearer  ' + token,
    }
  };

  axios(config).then((res) => {
    dispatch(hideIsLoading());
    if (res.status === 200) {
      dispatch({
        type: actionType.GET_BY_DOCTOR_SUCCESS,
        payload: res.data,
        message: res.data.message
      });
    } else if (res.status === 206) {
      dispatch({
        type: actionType.GET_BY_DOCTOR_FAILURE,
        error: res.data.message
      })
    }
  }).catch(error => {
    dispatch(hideIsLoading());
    if(error.response.data.error == "invalid_token"){
      dispatch(refreshApiService(getByDoctor))
    }
    dispatch({
      type: actionType.GET_BY_DOCTOR_FAILURE,
      error: error
    });
  });
};

export const getByLocation = () => dispatch => {
  toast.dismiss();

  // var formData = new FormData();
  // formData.append('location','');

  var formBody = [];
  formBody.push("location" + "=" + "");
  formBody = formBody.join("&");


  const config = {
    method: 'post',
    url: URL.patient.GET_BY_LOCATION,
    data: formBody,
    headers: {
      'Content-Type': "application/x-www-form-urlencoded",
    }
  };

  axios(config).then((res) => {
    if (res.status === 200) {
      dispatch({
        type: actionType.GET_BY_LOCATION_SUCCESS,
        payload: res.data,
        message: res.data.message
      });
    } else if (res.status === 206) {
      dispatch({
        type: actionType.GET_BY_LOCATION_FAILURE,
        error: res.data.message
      })
    }
  }).catch(error => {
     
    dispatch({
      type: actionType.GET_BY_LOCATION_FAILURE,
      error: error
    });
  });
};



export const searchByAll = (token, payload) => dispatch => {
  toast.dismiss();


  const config = {
    method: 'post',
    url: URL.patient.SEARCH_BY_ALL,
    data: payload,
    headers: {
      "Authorization": 'bearer  ' + token,
    }
  };
  axios(config).then((res) => {
    if (res.status === 200) {
      dispatch({
        type: actionType.SEARCH_BY_ALL_SUCCESS,
        payload: res.data,
        message: res.data.message
      });
    } else if (res.status === 206) {
      dispatch({
        type: actionType.SEARCH_BY_ALL_FAILURE,
        error: res.data.message,
        
      })
      toast.error(res.data.message);
    }
  }).catch(error => {
    if(error.response.data.error == "invalid_token"){
      dispatch(refreshApiService(searchByAll, payload))
   }
    dispatch({
      type: actionType.SEARCH_BY_ALL_FAILURE,
      error: error
    });
  });
};


export const getRecordsList = (token) => dispatch => {
  toast.dismiss();

  dispatch(showIsLoading());

  const config = {
    method: 'get',
    url: URL.patient.GET_RECORDS_LIST,
    headers: {
      'Content-Type': "application/json",
      "Authorization": 'bearer  ' + token,
    }
  };
  axios(config).then((res) => {
    dispatch(getResponseTimeList(token));
    dispatch(getAuthoExpList(token));
    dispatch(getOtherClassifications(token));
    dispatch(hideIsLoading());
    if (res.status === 200) {
      dispatch({
        type: actionType.GET_RECORDS_LIST_SUCCESS,
        payload: res.data,
        message: res.data.message
      });
    } else if (res.status === 206) {
      dispatch({
        type: actionType.GET_RECORDS_LIST_FAILURE,
        error: res.data.message
      })
    }
  }).catch(error => {
    dispatch(hideIsLoading());
    if(error.response.data.error == "invalid_token"){
      dispatch(refreshApiService(getRecordsList))
   }
    dispatch({
      type: actionType.GET_RECORDS_LIST_FAILURE,
      error: error
    });
  });
};

export const getOtherClassifications = (token) => dispatch => {
  toast.dismiss();

  dispatch(showIsLoading());

  const config = {
    method: 'get',
    url: URL.patient.GET_OTHER_CLASSIFICATIONS,
    headers: {
      'Content-Type': "application/json",
      "Authorization": 'bearer  ' + token,
    }
  };
  axios(config).then((res) => {
    dispatch(hideIsLoading());
    if (res.status === 200) {
      dispatch({
        type: actionType.GET_OTHER_CLASSIFICATIONS_SUCCESS,
        payload: res.data,
        message: res.data.message
      });
    } else if (res.status === 206) {
      dispatch({
        type: actionType.GET_OTHER_CLASSIFICATIONS_FAILURE,
        error: res.data.message
      })
    }
  }).catch(error => {
    dispatch(hideIsLoading());
    if(error.response.data.error == "invalid_token"){
      dispatch(refreshApiService(getOtherClassifications))
   }
    dispatch({
      type: actionType.GET_OTHER_CLASSIFICATIONS_FAILURE,
      error: error
    });
  });
};


export const disableMyAccount = (token, payload) => dispatch => {
  toast.dismiss();

  dispatch(showIsLoading());

  const config = {
    method: 'post',
    url: URL.patient.DISABLE_ACCOUNT,
    data:payload,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      "Authorization": 'bearer  ' + token,
    }
  };
  axios(config).then((res) => {
    dispatch(hideIsLoading());
    if (res.status === 200) {
      dispatch({
        type: actionType.DISABLE_ACCOUNT_SUCCESS,
        payload: res.data,
        message: res.data.message
      });
    } else if (res.status === 206) {
      dispatch({
        type: actionType.DISABLE_ACCOUNT_FAILURE,
        error: res.data.message
      })
    }
  }).catch(error => {
    dispatch(hideIsLoading());
    if(error.response.data.error == "invalid_token"){
      dispatch(refreshApiService(disableMyAccount, payload))
   }
    dispatch({
      type: actionType.DISABLE_ACCOUNT_FAILURE,
      error: error
    });
  });
};

export const enableMyAccount = (token, payload) => dispatch => {
  toast.dismiss();

  dispatch(showIsLoading());

  const config = {
    method: 'post',
    url: URL.patient.ENABLE_ACCOUNT,
    data:payload,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      "Authorization": 'bearer  ' + token,
    }
  };
  axios(config).then((res) => {
    dispatch(hideIsLoading());
    if (res.status === 200) {
      dispatch({
        type: actionType.ENABLE_ACCOUNT_SUCCESS,
        payload: res.data,
        message: res.data.message
      });
    } else if (res.status === 206) {
      dispatch({
        type: actionType.ENABLE_ACCOUNT_FAILURE,
        error: res.data.message
      })
    }
  }).catch(error => {
    dispatch(hideIsLoading());
    if(error.response.data.error == "invalid_token"){
      dispatch(refreshApiService(enableMyAccount, payload))
   }
    dispatch({
      type: actionType.ENABLE_ACCOUNT_FAILURE,
      error: error
    });
  });
};


export const verifyOtpEnableAcc = (token, payload) => dispatch => {
  toast.dismiss();

  dispatch(showIsLoading());

  const config = {
    method: 'post',
    url: URL.patient.VERIFY_OTP_ENABLE_ACCOUNT,
    data:payload,
    headers: {
      'Content-Type': "application/json",
      "Authorization": 'bearer  ' + token,
    }
  };
  axios(config).then((res) => {
    dispatch(hideIsLoading());
    if (res.status === 200) {
      dispatch({
        type: actionType.VERIFY_OTP_ENABLE_ACCOUNT_SUCCESS,
        payload: res.data,
        message: res.data.message
      });
    } else if (res.status === 206) {
      dispatch({
        type: actionType.VERIFY_OTP_ENABLE_ACCOUNT_FAILURE,
        error: res.data.message
      })
    }
  }).catch(error => {
    dispatch(hideIsLoading());
    if(error.response.data.error == "invalid_token"){
      dispatch(refreshApiService(verifyOtpEnableAcc, payload))
   }
    dispatch({
      type: actionType.VERIFY_OTP_ENABLE_ACCOUNT_FAILURE,
      error: error
    });
  });
};


export const getResponseTimeList = (token) => dispatch => {
  toast.dismiss();

  dispatch(showIsLoading());

  const config = {
    method: 'get',
    url: URL.patient.GET_RESPONSE_TIME_LIST,
    headers: {
      'Content-Type': "application/json",
      "Authorization": 'bearer  ' + token,
    }
  };
  axios(config).then((res) => {
    dispatch(hideIsLoading());
    if (res.status === 200) {
      dispatch({
        type: actionType.GET_RESPONSE_TIME_LIST_SUCCESS,
        payload: res.data,
        message: res.data.message
      });
    } else if (res.status === 206) {
      dispatch({
        type: actionType.GET_RESPONSE_LIST_TIME_FAILURE,
        error: res.data.message
      })
    }
  }).catch(error => {
    dispatch(hideIsLoading());
    if(error.response.data.error == "invalid_token"){
      dispatch(refreshApiService(getResponseTimeList))
   }
    dispatch({
      type: actionType.GET_RESPONSE_LIST_TIME_FAILURE,
      error: error
    });
  });
};

export const getAuthoExpList = (token) => dispatch => {
  toast.dismiss();

  dispatch(showIsLoading());

  const config = {
    method: 'get',
    url: URL.patient.GET_AUTH_EXP_LIST,
    headers: {
      'Content-Type': "application/json",
      "Authorization": 'bearer  ' + token,
    }
  };
  axios(config).then((res) => {
    dispatch(hideIsLoading());
    if (res.status === 200) {
      dispatch({
        type: actionType.GET_AUTH_EXP_LIST_SUCCESS,
        payload: res.data,
        message: res.data.message
      });
    } else if (res.status === 206) {
      dispatch({
        type: actionType.GET_AUTH_EXP_LIST_FAILURE,
        error: res.data.message
      })
    }
  }).catch(error => {
    dispatch(hideIsLoading());
    if(error.response.data.error == "invalid_token"){
      dispatch(refreshApiService(getAuthoExpList))
   }
    dispatch({
      type: actionType.GET_AUTH_EXP_LIST_FAILURE,
      error: error
    });
  });
};

export const getFacilityAddress = (token, payload, ) => dispatch => {
  toast.dismiss();

  dispatch(showIsLoading());

  const config = {
    method: 'get',
    url: URL.patient.GET_FACILITY_ADDRESS + payload.selectedFacilityId,
    headers: {
      'Content-Type': "application/json",
      "Authorization": 'bearer  ' + token,
    }
  };
  axios(config).then((res) => {
    dispatch(hideIsLoading());
    if (res.status === 200) {
      dispatch({
        type: actionType.GET_FACILITY_ADDRESS_SUCCESS,
        data: payload,
        payload: res.data,
        message: res.data.message
      });
    } else if (res.status === 206) {
      dispatch({
        type: actionType.GET_FACILITY_ADDRESS_FAILURE,
        error: res.data.message
      })
    }
  }).catch(error => {
    dispatch(hideIsLoading());
    if(error.response.data.error == "invalid_token"){
      dispatch(refreshApiService(getFacilityAddress, payload))
   }
    dispatch({
      type: actionType.GET_FACILITY_ADDRESS_FAILURE,
      error: error
    });
  });
};



export const getApproxCost = (token, payload, payloadForFinal , id, list,recordDetailsPayload) => dispatch => {
  toast.dismiss();

  dispatch(showIsLoading());

  const config = {
    method: 'post',
    url: URL.patient.GET_APP_COST,
    data: payload,
    headers: {
      "Authorization": 'bearer  ' + token,
    }
  };
 
  axios(config).then((res) => {
    dispatch(hideIsLoading());
    if (res.status === 200) {
      dispatch({
        type: actionType.GET_APP_COST_SUCCESS,
        requestData: payloadForFinal,
        recordDetails: recordDetailsPayload,
        typeId:id,
        pList:list,
        payload: res.data,
        message: res.data.message
      });
    } else if (res.status === 206) {
      dispatch({
        type: actionType.GET_APP_COST_FAILURE,
        error: res.data.message
      })
      toast.error(res.data.message);
    }
  }).catch(error => {
     dispatch(hideIsLoading());
    if(error.response.status  === 500){
     toast.error(error.response.data.message);
    
    }
   if(error.response.data.error == "invalid_token"){
    dispatch(refreshApiService(getApproxCost, payload, payloadForFinal, id, list, recordDetailsPayload))
   }
    dispatch({
      type: actionType.GET_APP_COST_FAILURE,
      error: error
    });
  });
};



export const addPaymentMethod = (token, payload, ) => dispatch => {
  toast.dismiss();

  dispatch(showIsLoading());

  const config = {
    method: 'post',
    url: URL.patient.ADD_PAYMENT_METHOD,
    data: payload,
    headers: {
      'Content-Type': "application/json",
      "Authorization": 'bearer  ' + token,
    }
  };

  axios(config).then((res) => {
    dispatch(hideIsLoading());
    if (res.status === 200) {
      dispatch(getPaymentMethods(token, payload.userId))
      dispatch({
        type: actionType.ADD_PAYMENT_METHOD_SUCCESS,
        payload: res.data,
        message: res.data.message
      });
      toast.success(res.data.message)
    } else if (res.status === 206) {
      dispatch({
        type: actionType.ADD_PAYMENT_METHOD_FAILURE,
        error: res.data.message
      })
      toast.error(res.data.message)
    }
  }).catch(error => {
    dispatch(hideIsLoading());
    if(error.response.data.error == "invalid_token"){
      dispatch(refreshApiService(addPaymentMethod, payload))
   }
    dispatch({
      type: actionType.ADD_PAYMENT_METHOD_FAILURE,
      error: error
    });
    toast.error(error.response.data.message)
  });
};



export const getPaymentMethods = (token, id, ) => dispatch => {
  toast.dismiss();

  dispatch(showIsLoading());

  const config = {
    method: 'get',
    url: URL.patient.GET_PAYMENT_METHODS + id,
    headers: {
      'Content-Type': "application/json",
      "Authorization": 'bearer  ' + token,
    }
  };

  axios(config).then((res) => {
    dispatch(hideIsLoading());
    if (res.status === 200) {
      dispatch({
        type: actionType.GET_PAYMENT_METHODS_SUCCESS,
        payload: res.data,
        message: res.data.message
      });
    } else if (res.status === 206) {
      dispatch({
        type: actionType.GET_PAYMENT_METHODS_FAILURE,
        error: res.data.message
      })
    }
  }).catch(error => {
    dispatch(hideIsLoading());
    if(error.response.data.error == "invalid_token"){
      dispatch(refreshApiService(getPaymentMethods, id))
   }
    dispatch({
      type: actionType.GET_PAYMENT_METHODS_FAILURE,
      error: error
    });
  });
};

  


export const costAgree = (token, payload, ) => dispatch => {
  toast.dismiss();

  dispatch(showIsLoading());

  const config = {
    method: 'post',
    url: URL.patient.COST_AGREE,
    data: payload,
    headers: {
      'Content-Type': "application/json",
      "Authorization": 'bearer  ' + token,
    }
  };

  axios(config).then((res) => {
    dispatch(hideIsLoading());
    if (res.status === 200) {
      dispatch({
        type: actionType.COST_AGREE_SUCCESS,
        message: res.data.message
      });
    } else if (res.status === 206) {
      dispatch({
        type: actionType.COST_AGREE_FAILURE,
        error: res.data.message
      })
    }
  }).catch(error => {
    dispatch(hideIsLoading());
    if(error.response.data.error == "invalid_token"){
      dispatch(refreshApiService(costAgree, payload))
   }
    dispatch({
      type: actionType.COST_AGREE_FAILURE,
      error: error
    });
  });
};



export const isAutoPay = (token, payload, ) => dispatch => {
  toast.dismiss();

  dispatch(showIsLoading());

  const config = {
    method: 'post',
    url: URL.patient.IS_AUTO_PAY,
    data: payload,
    headers: {
      'Content-Type': "application/json",
      "Authorization": 'bearer  ' + token,
    }
  };

  axios(config).then((res) => {
    dispatch(hideIsLoading());
    if (res.status === 200) {
      dispatch({
        type: actionType.IS_AUTO_PAY_SUCCESS,
        payload: res.data,
      });
    } else if (res.status === 206) {
      dispatch({
        type: actionType.IS_AUTO_PAY_FAILURE,
        error: res.data.message
      })
    }
  }).catch(error => {
    dispatch(hideIsLoading());
    if(error.response.data.error == "invalid_token"){
      dispatch(refreshApiService(isAutoPay, payload))
   }
    dispatch({
      type: actionType.IS_AUTO_PAY_FAILURE,
      error: error
    });
  });
};



export const isDefaultCard = (token, payload, id, ) => dispatch => {
  toast.dismiss();

  dispatch(showIsLoading());

  const config = {
    method: 'post',
    url: URL.patient.IS_DEFAULT_CARD,
    data: payload,
    headers: {
      'Content-Type': "application/json",
      "Authorization": 'bearer  ' + token,
    }
  };

  axios(config).then((res) => {
    dispatch(getPaymentMethods(token, id, ));
    dispatch(hideIsLoading());
    if (res.status === 200) {

      dispatch({
        type: actionType.IS_DEFAULT_CARD_SUCCESS,
        payload: res.data,
        message: res.data.message
      });
    } else if (res.status === 206) {
      dispatch({
        type: actionType.IS_DEFAULT_CARD_FAILURE,
        error: res.data.message
      })
    }
  }).catch(error => {
    dispatch(hideIsLoading());
    if(error.response.data.error == "invalid_token"){
      dispatch(refreshApiService(isDefaultCard, payload, id))
   }
    dispatch({
      type: actionType.IS_DEFAULT_CARD_FAILURE,
      error: error
    });
  });
};



export const deletePaymentMethod = (token, paymentId , id) => dispatch => {
  toast.dismiss();

  dispatch(showIsLoading());

  const config = {
    method: 'delete',
    url: URL.patient.DELETE_PAYMENT_METHOD + paymentId,
    headers: {
      'Content-Type': "application/json",
      "Authorization": 'bearer  ' + token,
    }
  };

  axios(config).then((res) => {
    dispatch(hideIsLoading());
    if (res.status === 200) {
      dispatch(getPaymentMethods(token, id, ));
      dispatch({
        type: actionType.DELETE_PAYMENT_METHOD_SUCCESS,
        payload: res.data,
        message: res.data.message
      });
      toast.success(res.data.message);
    } else if (res.status === 206) {
      dispatch({
        type: actionType.DELETE_PAYMENT_METHOD_FAILURE,
        error: res.data.message
      })
      toast.error(res.data.message);
    }
  }).catch(error => {
    dispatch(hideIsLoading());
    if(error.response.data.error == "invalid_token"){
      dispatch(refreshApiService(deletePaymentMethod, paymentId, id))
   }
    dispatch({
      type: actionType.DELETE_PAYMENT_METHOD_FAILURE,
      error: error
    });
  });
};

export const chargeFinalCost = (token, userId, id ,)=>dispatch=>{
  toast.dismiss();

  dispatch(showIsLoading());
 
  const config = {
    method: 'post',
    url: URL.patient.CHARGE_FINAL_COST,
    data:id,
    headers: {
      'Content-Type' : "application/json",
      "Authorization": 'bearer  ' + token,
    }   };
   axios(config).then((res) => {

    if (res.status === 200) {
      dispatch(getPatientRecordReqList(token, userId, ))
      dispatch(hideIsLoading());
 
       dispatch({
        type: actionType.CHARGE_FINAL_COST_SUCCESS,
        payload: res.data,
        message: res.data.message
      });
      toast.success(res.data.message)
    } else if (res.status === 206) {
 
      dispatch({
        type: actionType.CHARGE_FINAL_COST_FAILURE,
        error: res.data.message
      })
      toast.error(res.data.message)

    }
    
   }).catch(error => {
    dispatch(hideIsLoading());
    if(error.response.data.message === "Problem in Payment charge,please add payment method if not added (or) please contact admin for support"){
      dispatch({
        type: actionType.PAYMENT_NOT_ADDED,
       });
    }
    if(error.response.data.error == "invalid_token"){
      dispatch(refreshApiService(chargeFinalCost, userId, id))
   }
     dispatch({
       type: actionType.CHARGE_FINAL_COST_FAILURE,
       error: error
     });
     toast.error(error.response.data.message)
    });

};


export const downloadRecords = (token, userId, id ,)=>dispatch=>{
  toast.dismiss();

  dispatch(showIsLoading());
 
  const config = {
    method: 'get',
    url: URL.patient.DOWNLOAD_RECORDS,
    params:id,
     headers: {
      'Content-Type' : "application/json",
      "Authorization": 'bearer  ' + token,
    }   };
   axios(config).then((res) => {

    if (res.status === 200) {
      dispatch(hideIsLoading());
      dispatch(getPatientRecordReqList(token, userId, ))

       dispatch({
        type: actionType.DOWNLOAD_RECORDS_SUCCESS,
        payload: res.data,
        message: res.data.message
      });
      toast.success(res.data.message)
    } else if (res.status === 206) {
 
      dispatch({
        type: actionType.DOWNLOAD_RECORDS_FAILURE,
        error: res.data.message
      })
      toast.error(res.data.message)
    }
    
   }).catch(error => {
    dispatch(hideIsLoading());
    if(error.response.data.error == "invalid_token"){
      dispatch(refreshApiService(downloadRecords, userId, id))
   }
     dispatch({
       type: actionType.DOWNLOAD_RECORDS_FAILURE,
       error: error
     });
     toast.error(error.message)
    });

};

export const validateFedexAvailability = (token, state, payload, payloadForFinal, id, list,recordDetailsPayload)=>dispatch=>{
  toast.dismiss();

  dispatch(showIsLoading());
  const config = {
    method: 'post',
    url: URL.patient.VALIDATE_FEDEX_AVAIL,
    data:state,
     headers: {
      'Content-Type' : "application/json",
      "Authorization": 'bearer  ' + token,
    }   };
 
   axios(config).then((res) => {

    if (res.status === 200) {
      dispatch(hideIsLoading());
      dispatch(getApproxCost(token, payload, payloadForFinal, id, list,recordDetailsPayload ))

       dispatch({
        type: actionType.VALIDATE_FEDEX_AVAIL_SUCCESS,
        payload: res.data,
        message: res.data.message
      });
      //toast.success(res.data.message)
    } else if (res.status === 206) {
      dispatch(hideIsLoading());
      dispatch({
        type: actionType.VALIDATE_FEDEX_AVAIL_FAILURE,
        error: res.data.message
      })
      toast.error(res.data.message)
    }
    
   }).catch(error => {
    dispatch(hideIsLoading());
    if(error.response.data.error == "invalid_token"){
      dispatch(refreshApiService(validateFedexAvailability, state, payload, payloadForFinal, id, list,recordDetailsPayload))
   }
     dispatch({
       type: actionType.DOWNLOAD_RECORDS_FAILURE,
       error: error
     });
     toast.error(error.message)
    });

};


export const makeNewRequestStatus = () => dispatch => {
  toast.dismiss();

  
  dispatch({
    type: actionType.MAKE_NEW_FACILITY_REQUEST,
   
  })
 
};

export const makePatientRegisterStatus = () => dispatch => {
  
  dispatch({
    type: actionType.MAKE_PATIENT_REGISTER_STATUS,
   
  })
};

export const InitialStatusNull = () => dispatch => {
  
  dispatch({
    type: actionType.INITIAL_STATUS_NULLIFY,
   
  })
};

export const agreePayNull = () => dispatch => {
  
  dispatch({
    type: actionType.AGREEPAY_NULL,
   
  })
};

export const nullifyPaymentAddingPage = () => dispatch => {
  dispatch({
    type: actionType.PAYMENT_ADD_NAV_NULL,
   
  })
   
};
